import React from 'react';
import { useSelector } from 'react-redux';

import { MachineStateIconContainer } from '../MachineStatesIcon.elements';
import { useBuSettings, useMachineInfo } from 'common/pages/fleetV2/providers';
import { useFleetRouter } from 'common/pages/fleetV2/hooks/useFleetRouter';
import { iopsApi } from 'api';
import { getZonedStartOfDay } from 'common/helpers/dateAndTimeHelpersV2';

const useMachineState = () => {
  const { colors, Icons } = useBuSettings();
  const [{ id }] = useFleetRouter();
  const { timeZone } = useMachineInfo();

  const currentData = useSelector((state) => iopsApi.endpoints.getProsealMachineOverview.select({ machineId: id, beginning_of_day_utc: getZonedStartOfDay(timeZone as string).utc })(state))
  const currentState = currentData?.data?.latest_machine_status ? currentData?.data?.latest_machine_status : undefined
  const currentStateCategory = currentData?.data?.latest_machine_status_category ? currentData?.data?.latest_machine_status_category :  undefined

  
  const label = currentStateCategory ? (currentStateCategory as unknown as string).toString().toLowerCase() : 'unknown'
  const state = currentState ? currentState : 'unknown'

  return {
    state,
    color: colors?.[label],
    Icon: Icons?.[label]
  };
};

export const ProsealMachineStateIcon = (): JSX.Element => {
  const { color, state, Icon } = useMachineState();

  return (
    <div className="machine-info-bar__item machine-state">
      Machine State:
      <MachineStateIconContainer className="machine-state-icon" {...{ color }}>
        <span className="label">{state}</span> {Icon}
      </MachineStateIconContainer>
    </div>
  );
};
